// extracted by mini-css-extract-plugin
module.exports = {"footer":"TripCartPanelPriceDetails_footer__WvTGo","root":"TripCartPanelPriceDetails_root__pxclf","captainFeeInfo":"TripCartPanelPriceDetails_captainFeeInfo__6p8eW"};